define('gumbo-js-client-lib/forms/liveData/OffenseForm',{
	ondeck: null,
	inhole: null,
	batter: null,
	first: null,
	second: null,
	third: null,
	teamID: null,
	team: null
});
